import { useState, useEffect } from "react";
import MainContainer from "../../components/app/maincontainer";
import Header from "../../components/partials/header";
import { SlOptionsVertical } from "react-icons/sl";
import { SearchInput } from "../../components/inputs/main";
import UsersTable, {
	PendingUsersTable,
} from "../../components/tables/userstable";
import { useNavigate, useParams } from "react-router-dom";
import { AddUsersModal } from "../../components/modals/addtoolsmodal";
import RawSample from "../../assets/User Invite Sample.xlsx";
import { useUsersStore } from "../../data/stores/loggerStore";
import { apiCall } from "../../data/useFetcher";
import { LoadMore, MainPaginate } from "../../components/app/buttons";

const Users = () => {
	const [tab, setTab] = useState("all users"),
		tabs = ["all users", "pending invitations"],
		[modal, setModal] = useState(""),
		{ page } = useParams(),
		navigate = useNavigate();

	let { getLogger, getDynamicLogger } = useUsersStore();

	useEffect(() => {
		apiCall({
			type: "get",
			url: `/api/v1/user/manage-users${
				tab !== tabs?.[0] ? `?statusText=pending` : ""
			}`,
			getter: (d: any) =>
				tab !== tabs?.[0] ? getDynamicLogger(d, "pending") : getLogger(d),
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tab]);

	return (
		<div>
			<MainContainer>
				<Header
					btn1Text={"Bulk Upload"}
					btn2Text={"Add New User"}
					handleAdd={() => navigate("/users/add-user")}
					handleModal={() => setModal("add")}
					text={page}
				/>
				<div className="mt-8 bg-white rounded-lg p-6">
					<div className="h-16 border-b border-b-[#E3E3E3] flex gap-4">
						{tabs?.map(t => (
							<button
								onClick={() => setTab(t)}
								className={`h-full capitalize px-1 text-base ${
									tab === t
										? "font-medium border-b-4 text-[#111014] border-b-[#2658AB]"
										: "font-normal border-b-none text-[#878789]"
								}`}>
								{t}
							</button>
						))}
					</div>
					<MainSection tab={tab} tabs={tabs} />
				</div>

				{modal === "add" && (
					<AddUsersModal
						handleClose={() => setModal("")}
						handleImport={pres => {
							navigate("add-user", { state: pres });
							setModal("");
						}}
						sample={RawSample}
					/>
				)}
			</MainContainer>
		</div>
	);
};
const MainSection = ({ tab, tabs }) => {
	let [datum, setDatum] = useState({ docs: [] }),
		{ getLogger, mainSearch, isFound, data, pending, getDynamicLogger }: any =
			useUsersStore(),
		[loading, setLoading] = useState<string | boolean>(false);

	useEffect(() => {
		if (isFound) setDatum(mainSearch);
		else setDatum(tab === tabs?.[1] ? pending : data);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data, isFound, mainSearch, tab, pending]);

	const handleLoadMore = async () => {
		setLoading("loadmore");
		await apiCall({
			type: "get",
			url: `/api/v1/user/manage-users?limit=${data?.limit * data?.nextPage}${
				tab !== tabs?.[0] ? `&statusText=pending` : ""
			}`,
			getter: (d: any) =>
				tab !== tabs?.[0] ? getDynamicLogger(d, "pending") : getLogger(d),
		});
		setLoading(false);
	};

	const [itemOffset, setItemOffset] = useState(0);
	let [range] = useState(10);
	const endOffset = itemOffset + range;

	// if (!datum && !data) return <PageLoader />;
	if (!datum) return;

	const currentItems = datum?.docs?.slice(itemOffset, endOffset);
	const pageCount = Math.ceil(datum?.docs?.length / range);

	const handlePageClick = (event: any) => {
		const newOffset = (event.selected * range) % datum?.docs?.length;
		setItemOffset(newOffset);
	};

	return (
		<>
			<div className="h-24 flex justify-between items-center w-full">
				<div className="flex gap-3 items-center">
					<input
						type="checkbox"
						name=""
						className="form-checkbox size-5 border border-[#ccc]"
						id=""
					/>
					<SlOptionsVertical color="#757575" />
					<SearchInput placeholder="Search" icon="jam:search" />
				</div>
				<div className="flex gap-4 items-center">
					<h4 className="text-base font-normal text-da-blue-600">Sort By</h4>
					<select
						name=""
						className="form-select text-base font-normal text-[#130019] h-10 w-40 border-[0.5px] border-[#ccc] rounded-lg px-3"
						id="">
						<option value="" selected>
							Most Recent
						</option>
					</select>
					<select
						name=""
						className="form-select text-base font-normal text-[#130019] h-10 w-40 border-[0.5px] border-[#ccc] rounded-lg px-3"
						id="">
						<option value="" selected>
							Most Recent
						</option>
					</select>
				</div>
			</div>
			{tab === "all users" ? (
				<UsersTable data={currentItems} />
			) : (
				<PendingUsersTable data={currentItems} />
			)}
			<div className="mt-10 flex justify-center w-44 items-center mx-auto">
				<LoadMore
					next={data?.hasNextPage}
					loading={loading === "loadmore"}
					handleLoadMore={handleLoadMore}
				/>
			</div>
			{pageCount > 1 && (
				<MainPaginate pageCount={pageCount} handlePageClick={handlePageClick} />
			)}
		</>
	);
};

export default Users;
